import { SOCIAL_LINKS } from "@/config/site";
import { SITE_COPY } from "@/content/site";
import { escapeAttribute, escapeHtml } from "./escape";

type SocialLink = (typeof SOCIAL_LINKS)[number];

function renderNativeLinkAttributes(link: SocialLink): string {
  const attributes: string[] = [];
  if (link.href.startsWith("http")) attributes.push('target="_blank"', 'rel="noreferrer"');
  if (link.download === true) attributes.push("download");
  return attributes.join(" ");
}

export function renderSocialFooter(modifier = "home"): string {
  const items = SOCIAL_LINKS.map((link) => {
    return `
      <li class="social-footer__item">
        <a
          class="interactive-link social-footer__link"
          href="${escapeAttribute(link.href)}"
          data-cursor-interaction
          ${renderNativeLinkAttributes(link)}
        >
          <img class="social-footer__icon" src="${escapeAttribute(link.icon)}" alt="" width="20" height="20" />
          <span>${escapeHtml(link.label)}</span>
        </a>
      </li>`;
  }).join("");

  return `
    <footer class="social-footer social-footer--${escapeAttribute(modifier)}">
      <p class="social-footer__eyebrow">${escapeHtml(SITE_COPY.footer.label)}</p>
      <nav class="social-footer__nav" aria-label="Social links"><ul class="social-footer__list">${items}</ul></nav>
      <p class="social-footer__copyright">© ${escapeHtml(SITE_COPY.footer.copyright)}</p>
    </footer>`;
}

export function renderSocialDock(): string {
  const items = SOCIAL_LINKS.map(
    (link) => `
      <li class="social-dock__item">
        <a
          class="interactive-link social-dock__link"
          href="${escapeAttribute(link.href)}"
          aria-label="${escapeAttribute(link.label)}"
          data-cursor-interaction
          ${renderNativeLinkAttributes(link)}
        >
          <img class="social-dock__icon" src="${escapeAttribute(link.icon)}" alt="" width="20" height="20" />
          <span class="social-dock__tooltip" aria-hidden="true">${escapeHtml(link.label)}</span>
        </a>
      </li>`
  ).join("");

  return `
    <nav class="social-dock" aria-label="Quick social links" aria-hidden="true" data-social-dock inert>
      <ul class="social-dock__list">${items}</ul>
    </nav>`;
}
